/** biome-ignore-all lint/complexity/noExcessiveLinesPerFunction: TODO: migrate to react-query */

import { DEFAULT_STORE_OBJECT } from '@/redux/constants';
import type { DefaultStoreObject } from '@/redux/types';
import type { OverChargeClaimDetailed, OverChargeSearchFilters } from '@/views/screens/Claims/types';

import { OVERCHARGE_CLAIMS_FILTERS_INITIAL_DATA } from '../../../contants/ClaimsEnums';
import { SEARCH_VIEW_TYPES, type SearchViewType } from '../../../contants/common';
import { OverChargeClaimsTypes } from './OverChargeTypes';

export interface OverChargeClaimsState {
  claimsFilters: OverChargeSearchFilters;
  editDrawer: boolean;
  selectedClaims: number[];
  editTabKey: string;
  claimViewMode: SearchViewType;
  claimDetails: DefaultStoreObject<OverChargeClaimDetailed>;
  itemsFromExcel: DefaultStoreObject<unknown>;
}

const initialState: OverChargeClaimsState = {
  claimDetails: {
    ...DEFAULT_STORE_OBJECT,
    data: {} as OverChargeClaimDetailed,
  },
  claimsFilters: OVERCHARGE_CLAIMS_FILTERS_INITIAL_DATA,
  claimViewMode: SEARCH_VIEW_TYPES.CARD,
  editDrawer: false,
  editTabKey: '1',
  itemsFromExcel: {
    ...DEFAULT_STORE_OBJECT,
    data: [],
  },
  selectedClaims: [],
};

// biome-ignore lint/suspicious/noExplicitAny: TODO: fix
export const OverChargeClaimsReducer = (state = initialState, { type, payload }: any): OverChargeClaimsState => {
  switch (type) {
    case OverChargeClaimsTypes.SET_OVERCHARGE_FILTERS: {
      return {
        ...state,
        claimsFilters: {
          ...state.claimsFilters,
          ...payload,
        },
      };
    }

    case OverChargeClaimsTypes.SET_OVERCHARGE_CLAIM_EDIT_ACTIVE_KEY: {
      return {
        ...state,
        editTabKey: payload,
      };
    }

    case OverChargeClaimsTypes.SET_OVERCHARGE_EDIT_DRAWER: {
      return {
        ...state,
        editDrawer: payload,
        ...(payload && { editTabKey: '1' }),
      };
    }

    case OverChargeClaimsTypes.SET_SELECTED_OVERCHARGE_CLAIMS: {
      return {
        ...state,
        selectedClaims: payload,
      };
    }
    case OverChargeClaimsTypes.GET_ITEMS_FROM_EXCEL_PROGRESS: {
      return {
        ...state,
        itemsFromExcel: {
          ...DEFAULT_STORE_OBJECT,
          data: [],
          progressing: true,
        },
      };
    }
    case OverChargeClaimsTypes.GET_ITEMS_FROM_EXCEL_SUCCESS: {
      return {
        ...state,
        itemsFromExcel: {
          ...DEFAULT_STORE_OBJECT,
          success: true,
          ...payload,
        },
      };
    }
    case OverChargeClaimsTypes.GET_ITEMS_FROM_EXCEL_ERROR: {
      return {
        ...state,
        itemsFromExcel: {
          ...DEFAULT_STORE_OBJECT,
          data: [],
          error: true,
          ...payload,
        },
      };
    }

    case OverChargeClaimsTypes.SET_CLAIM_SEARCH_VIEW_TYPE_INITIAL:
    case OverChargeClaimsTypes.SET_CLAIM_SEARCH_VIEW_TYPE: {
      return {
        ...state,
        claimViewMode: payload,
      };
    }

    default:
      return state;
  }
};
